<template>
  <div class = "st-table">
    <el-card shadow="always" style="width: 100%">
      <el-form class="form" ref="query" :model="query" :rules="rules" label-position="left" label-width="145px" label-colon >
        <el-row :gutter="16">
          <el-col :span="8">
            <el-form-item label="Month" :span="16" prop="month">
              <el-date-picker
                type="months"
                v-model="query.month"
                placeholder="Please Input"
                style="width: 100%"
                value-format="yyyy-MM"
                clearable
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <el-form-item
              label="User"
            >
              <el-select
                v-model="query.user"
                filterable
                clearable
                multiple
                style="width: 100%"
                :loading="loading1"
              >
                <el-option
                  v-for="(item) in userList"
                  :value="item.value"
                  :key="item.label"
                  :label="item.label"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="3">
            <el-form-item label="Class">
              <el-cascader
                v-model= "cateVal"
                :options = "cateList"
                :props="{ checkStrictly: true }"
                placeholder="Please Input"
                clearable
                filterable
                @change="handleChange"
                style="width:260px"
              >
              </el-cascader>
            </el-form-item>
          </el-col>
        </el-row>

        <div style="margin-top: 5px; text-align: left">
          <el-button type="primary" @click="getReportSummaryList">
            Search
          </el-button>
          <el-button type="primary" @click="getReportSummaryExcel">
            Export
          </el-button>
        </div>

<!--        <el-row :gutter="16">-->
<!--          <el-col :span="6">-->
<!--            <el-button type="primary" :span="3" @click="getReportSummaryList">-->
<!--              Search-->
<!--            </el-button>-->
<!--          </el-col>-->
<!--          <el-col :span="10">-->
<!--            <el-button type="primary" :span="6" @click="getReportSummaryExcel">-->
<!--              Export-->
<!--            </el-button>-->
<!--          </el-col>-->
<!--        </el-row>-->
      </el-form>
    </el-card>
    <br/>
    <el-card shadow="always" title="Weekly Report" label-width="145px" label-colon>
      <el-form>
        <el-row :gutter="16">
          <el-table
            :data="reportSummaryList"
            border
            show-summary
            style="width: 100%">
            <el-table-column
              prop="fullName"
              label="User"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="weekStart"
              label="Week Start"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="weekEnd"
              label="Week End"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="category"
              label="Class-Lv1"
              width="140"
            >
            </el-table-column>

            <el-table-column
              prop="category2nd"
              label="Class-Lv2"
              width="160"
            >
            </el-table-column>

            <el-table-column
              prop="category3rd"
              label="Class-Lv3"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="subClass"
              label="Sub Class"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="time"
              label="Hour"
              width="100"
            >
            </el-table-column>

            <el-table-column
              prop="percentage"
              label="Progress"
              width="120"
            >
            </el-table-column>

            <el-table-column
              prop="description"
              label="Description"
              width="300"
            >
            </el-table-column>
          </el-table>
        </el-row>
      </el-form>
    </el-card>

    <!--    <el-row :gutter="16">-->
    <!--      <el-card>-->
    <!--        <div-->
    <!--          id="report"-->
    <!--        >-->
    <!--        </div>-->
    <!--      </el-card>-->

    <!--    </el-row>-->
  </div>
</template>

<script>
import reportApi from '@/api/report.js';
import userApi from "@/api/user";

export default {
  name: "reportSummary",
  data() {
    return {
      loading: false,
      cateVal: [],
      cateList: [],
      reportSummaryList: [],
      userList:[],
      bar: [],
      editIndex: -1,
      isEdit: -99,
      loading1: false,
      query: {
        month:'',
        user:'',
        category:'',
        category2nd:'',
        currentPage:'',
        totalPage:'',
        pageSize:'',
      },
      rules:{
        month: [{
          required:true, message:'Please Input', trigger:'blur'
        }]
      }
      // rules:{
      //   month: [{
      //     required:true, message:'Please Input', trigger:'blur'
      //   }],
      // },
    }
  },

  methods: {
    getCategoryList() {
      reportApi.getCategory().then(
        res => {
          this.cateList = res.data.data
        }
      )
    },
    getReportSummaryList() {
      this.$refs.query.validate((valid) => {
          if (valid) {
            let data = {}
            if (this.query.month) {
              data['months'] = this.query.month
            }
            if (this.query.user) {
              data['user_ids'] = this.query.user
            }
            if (this.cateVal) {
              data['category'] = this.cateVal[0]
              data['category2nd'] = this.cateVal[1] ? this.cateVal[1] : null
            }
            data['offset'] = this.query.pageSize * (this.query.currentPage -1)
            data['limit'] = this.query.pageSize
            reportApi.getReportSummary(data).then(
              res => {
                this.reportSummaryList = res.data.data
                this.query.totalPage = res.data.total
              }
            )
          } else {
            this.$message.error("Please filled with Month")
          }
      })
    },

    async getReportSummaryExcel() {
      this.$refs.query.validate((valid) => {
        if (valid) {
          let data = {}
          if (this.query.month) {
            data['months'] = this.query.month
          }
          if (this.query.user) {
            data['user_ids'] = this.query.user
          }
          if (this.cateVal) {
            data['category'] = this.cateVal[0]
            data['category2nd'] = this.cateVal[1] ? this.cateVal[1] : null
          }
          reportApi.getReportSummaryExcel(data).then(
            resp => {
              const blob = new Blob([resp])
              console.log(blob)
              const url = URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = url
              link.download = 'data.xls'
              link.click()
              // 释放URL对象
              URL.revokeObjectURL(url)
            }
          )
        } else {
          this.$message.error("Please filled with Month")
        }
      })
    },


    handleChange() {
      console.log(this.cateVal);
    },
    // dataFilter(node: { text: string; }, val: string) {
    //   if (!!~node.text.indexOf(val) || !!~node.text.toUpperCase().indexOf(val.toUpperCase())) {
    //     return true
    //   }
    // },
    getSelects() {
      userApi.getUsers().then(res=> {
        let users = res.data
        for (let user of users) {
          this.userList.push({value: user.id, label: user['fullName']})
        }
      })
    },

  },
  mounted() {
    this.getSelects()
    this.getCategoryList()
  }
}
</script>

<style lang="scss" scoped>
.st-table {
  padding:10px
}

</style>
